<script setup lang="ts">
import { PhxsgProductCard } from '@sg/src/View/Components/Molecules/ProductCard';
import WishlistButton from '@maison/components/wishlist/WishlistButton.vue';
import { PhxPictureProps } from '@sg-core/src/View/Components/Atoms/Picture';
import { omit } from 'lodash-es';
import ProductPrice, { ProductPriceProps } from '@phoenix/components/common/ProductPrice.vue';
import { usePrice } from '@phoenix/composables/price';

export interface ProductCardProps {
  reference: string;
  title: string;
  description?: string;
  href: string;
  images: PhxPictureProps[];
  tag?: string;
  prices: {
    price: Record<string, ProductPriceProps>;
    shouldDisplayFromPrice: boolean;
  };
}

defineProps<ProductCardProps>();

const { localizedPrice } = usePrice();
</script>

<template>
  <PhxsgProductCard v-bind="omit($props, ['prices'])">
    <template #wishlist-button>
      <WishlistButton :reference="reference" :name="title" new-sg />
    </template>

    <template #price>
      <ProductPrice v-bind="localizedPrice(prices.price)" :should-display-from-price="prices.shouldDisplayFromPrice" />
    </template>
  </PhxsgProductCard>
</template>
